// P1-012: Bottom navigation bar — 6 functional buttons

import { useProjectStore } from '@/shared/stores/projectStore';

export type NavTab = 'projects' | 'hardware' | 'summon' | 'collection' | 'settings';

interface NavBarProps {
  activeTab: NavTab | null;
  onTabChange: (tab: NavTab) => void;
}

const NAV_ITEMS: { tab: NavTab; label: string; icon: string }[] = [
  { tab: 'projects',   label: '项目',  icon: '/assets/icons/nav/icon_nav_orders.webp' },
  { tab: 'hardware',   label: '硬件',  icon: '/assets/icons/nav/icon_nav_hardware.webp' },
  { tab: 'summon',     label: '召唤',  icon: '/assets/icons/nav/icon_nav_summon.webp' },
  { tab: 'collection', label: '图鉴',  icon: '/assets/icons/nav/icon_nav_collection.webp' },
  { tab: 'settings',   label: '设置',  icon: '/assets/icons/nav/icon_nav_settings.webp' },
];

export function NavBar({ activeTab, onTabChange }: NavBarProps) {
  const hasNewBattle = useProjectStore(s => s.hasUnplayedProjects('battle'));
  const hasNewMaintenance = useProjectStore(s => s.hasUnplayedProjects('maintenance'));

  return (
    <nav className="navbar">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.tab}
          className={`navbar__btn ${activeTab === item.tab ? 'navbar__btn--active' : ''}`}
          onClick={() => onTabChange(item.tab)}
        >
          <img className="navbar__icon" src={item.icon} alt={item.label} />
          <span className="navbar__label">{item.label}</span>
          {item.tab === 'projects' && (hasNewBattle || hasNewMaintenance) && <span className="navbar__badge" />}
        </button>
      ))}
    </nav>
  );
}
